import { render, staticRenderFns } from "./AppQRCode.vue?vue&type=template&id=f94465f4&scoped=true&"
import script from "./AppQRCode.vue?vue&type=script&lang=js&"
export * from "./AppQRCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94465f4",
  null
  
)

export default component.exports